import { render, staticRenderFns } from "./xeChartRadarSetting.vue?vue&type=template&id=f5cad2fc"
import script from "./xeChartRadarSetting.vue?vue&type=script&lang=js"
export * from "./xeChartRadarSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports